import React, { useMemo, useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  Button,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import { SearchBar as RSKSearchBar } from '@uncinc/react-searchkit';
import { SearchBarProps as Type } from '@uncinc/react-searchkit/dist/components/SearchBar';
import { SCREEN_WIDE } from '../../../config/constants';

import './style.scss';

export interface SearchBarProps extends Type {
  type?: 'primary' | 'secondary';
  className?: string;
  autoFocus?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = (props) => {
  const {
    type = 'primary',
    placeholder,
    buttonText,
    className,
    ...restProps
  } = props;

  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const classNames = c(`SearchBar--${type}`, className);
  const isSmallScreen = useMemo(() => width < SCREEN_WIDE, [width]);
  const ref = useRef<HTMLElement>(null);

  const SearchBarButton = React.useCallback((buttonProps: any) => (
    <Button
      {...buttonProps}
      {... {
        primary: false,
        icon: 'search',
        variant: 'icon-only',
        'aria-label': buttonText || t('buttons.search'),
      }}
      className="SearchBar__button__wrapper inline Button--search"
    >
      <i className="SearchBar__button icon icon-search" />
    </Button>
  ), [buttonText, t]);

  return (
    <div className="SearchBar--wrapper">
      <RSKSearchBar
        {...restProps}
        className={classNames}
        ref={ref}
        placeholder={isSmallScreen ? t('components.search_all_content.search_bar.mobile_placeholder') : placeholder}
        button={SearchBarButton}
      />
    </div>
  );
};

export default SearchBar;
